import clsx from "clsx";
import React from "react";

interface InputProps {
  name: string;
  label?: string;
  id?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  warning?: boolean;
  className?: string;
  placeholder?: string;
  type?: string;
  value?: any;
  min?: string;
  max?: string;
  autoComplete?: string;
  onBlur?: (_: any, name: string) => void;
  onKeyDown?: (_: any) => void;
  onChange?: (_: any, name: string) => void;
}

const Input: React.FC<InputProps> = ({
  label, id, disabled, name, required, error, errorMessage, warning, className, placeholder, type, value, min, max, autoComplete, onBlur, onKeyDown, onChange
}) => {
  return (
    <>
      <input
        id={id}
        name={name}
        className={`form-control ${error ? 'is-invalid' : ''} ${className || ""}`}
        placeholder={placeholder}
        type={type}
        value={value}
        min={min}
        max={max}
        autoComplete={autoComplete || "off"}
        onBlur={(e) => onBlur && onBlur(e, name)}
        onKeyDown={onKeyDown}
        onChange={(e) => onChange && onChange(e, name)}
        disabled={disabled}
        required={required}
      />
      {label && <label htmlFor={id}>{label} {required && <span className="text-danger">*</span>}</label>}
      {
        (error || warning) &&
        <div className={clsx(`fv-plugins-message-container fv-plugins-message-container--enabled`, error && 'invalid-feedback', warning && 'warning-feedback')}>
          <div data-field={id} data-validator={error ? 'notEmpty' : 'warning'}>
            {errorMessage}
          </div>
        </div>
      }
    </>
  )
};

export default Input;